export default {
  "Fleet_Resdesign_Error_OWDd": "Недійсний формат електронної адреси",
  "Fleet_0303_Fleet_WorkRegime_daily_ztIr": "Стягується щодня в період часу з 00:00 до 12:00",
  "Fleet_2_To_be_Egnx": "Не підключені",
  "Fleet_tittle_The_maximum_tjjA": "Максимальний проміжок часу, який можна вибрати, — {{max_time_span}} дн.",
  "Fleet_Resdesign_All_XnPT": "Усі",
  "Fleet_Resdesign_View_Income_PiyV": "Переглянути деталі доходу",
  "Fleet_Resdesign_Thursday_JOxF": "Чт",
  "upt-city---rwrap_fail": {
    "wtext": "Не вдалось оновити",
    "wstext1": "Цю модель не можна тут використовувати.",
    "wstext2": "Помилка…",
    "wstext3": "Змінено"
  },
  "Fleet_0303_Fleet_WorkRegime_monthly_XmGW": "Стягується першого числа кожного місяця в період часу з 00:00 до 12:00",
  "upt-city---search": {
    "city-location-none": "Помилка визначення розташування",
    "data_sub": "Назва міста",
    "search-content-title": "Пошук міста",
    "didi-dialog-p": "Місто можна змінити певну кількість разів (<em class='org'>{ctime}</em>) протягом <em class='org'>6</em> місяців",
    "btn-ok": "OK",
    "back": "Назад",
    "btn-cancel": "Скасувати",
    "city-location-title": "Попереднє місто",
    "city-popular-title": "Популярні міста"
  },
  "Fleet_Resdesign_Cash_XfVb": "Готівка",
  "Fleet_Resdesign_July_Zroi": "Лип",
  "GDriver_Enhancement_Repayment_INQd": "Оплатити повторно",
  "Fleet_Resdesign_August_mcie": "Сер",
  "Fleet_Resdesign_Calendar_mFPf": "Календар",
  "Fleet_Resdesign_November_kXkU": "Листоп",
  "Fleet_Resdesign__Biaz": "Бер",
  "dinfo---details": {
    "driver_city_title": "Ваше місто",
    "driver_name_title": "Повне ім’я",
    "car_type": "Категорія"
  },
  "Fleet_Resdesign_End_HlIj": "Кінець",
  "Fleet_Resdesign_Enter_the_ejUB": "Введіть електронну адресу, щоб отримати звіт про дохід у форматі CSV",
  "Fleet_Resdesign_Income_summary_PZsP": "Підсумок доходу",
  "Fleet_0303_Fleet_WorkRegime_Weekly_collection_PFfF": "Стягується щопонеділка в період часу з 00:00 до 12:00",
  "upt-city---tips": "Забагато внесених змін",
  "Fleet_0303_Fleet_WorkRegime_Enter_name_hIvg": "Виберіть назву платежу",
  "Fleet_Resdesign_No_data_CqQU": "Немає даних",
  "Fleet_Resdesign_Saturday_mzeO": "Сб",
  "Fleet_Resdesign__ucKv": "Тра",
  "Fleet_FleetRecommendation_Successfully_saved_wLuW": "Збережено",
  "Fleet_DriverUnbindFleet_Bind_afzf": "Підключені",
  "Fleet_Resdesign_Sunday_jiVr": "Нд",
  "Fleet_0303_Fleet_WorkRegime_everyday_BKeT": "Щодня",
  "Fleet_Resdesign_Select_Start_CdGi": "Час початку",
  "Fleet_Resdesign_Income_flow_fcPZ": "Деталі доходу",
  "Fleet_Resdesign_Confirmation_McBF": "ОК",
  "Fleet_Resdesign_Heaven_Qvoz": "дн.",
  "Fleet_Resdesign_Total_lDoG": "Загальна сума, отримана готівкою",
  "Fleet_Resdesign_Total_income_XZbI": "Загальний дохід",
  "dinfo---bank": "Банківський рахунок",
  "Fleet_Resdesign_January_MKno": "Січ",
  "magellan": {
    "martell": {
      "translate": {
        "order_compensate": {
          "driver_channel": {
            "1": "Баланс"
          }
        }
      }
    }
  },
  "Fleet_Resdesign_Select_End_qdXu": "Час закінчення",
  "Fleet_Resdesign_Sent_successfully_wwMu": "Надіслано",
  "Fleet_Resdesign_June_slTp": "Чер",
  "Fleet_Resdesign_Page_Name_OKXD": "Початок",
  "Fleet_Resdesign_Clear_uVXL": "Очистити",
  "Fleet_Resdesign_Wednesday_IHFc": "Ср",
  "Fleet_Resdesign_Load_last_YWoz": "Попередній місяць",
  "Fleet_Resdesign_Monday_bazB": "Пн",
  "Fleet_Resdesign_Send_IBLm": "Надіслати",
  "Fleet_Resdesign_Cash_LiLC": "Готівка",
  "Fleet_0303_Fleet_WorkRegime_weekly_fELn": "Щотижня",
  "Fleet_0303_Fleet_WorkRegime_amount_obtained_otsv": "Укажіть суму, яку отримуватимете",
  "Fleet_Resdesign_October_pbZU": "Жовт",
  "Fleet_Resdesign_Enter_email_cylU": "Введіть електронну адресу",
  "Fleet_Resdesign_Total_tUqe": "Депозит профілю",
  "Fleet_Resdesign_Slide_more_YbCQ": "Змахніть угору — завантажите більше",
  "Fleet_FleetRecommendation_Enter_the_Ykpv": "Введіть суму в правильному форматі",
  "Fleet_Resdesign_Start_SDWR": "Початок",
  "Fleet_Resdesign_September_MGfs": "Верес",
  "upt-city---index_city_title": "Місто",
  "Fleet_Resdesign_Driver_Summary_zoSe": "Підсумок доходу водія",
  "Fleet_Resdesign_February_XtXo": "Лют",
  "Fleet_MultiUserLogin_Add_succeed_kBCi": "Додано",
  "Fleet_Resdesign_Data_loading_pcxE": "Завантаження даних…",
  "Fleet_Resdesign_April_Qtaf": "Кві",
  "Fleet_0303_Fleet_WorkRegime_Monthly_uzwN": "Щомісяця",
  "Fleet_Resdesign_Save_it_uMek": "Запам’ятати цю електронну адресу?",
  "Fleet_FMS_You_have_pFWa": "Не заповнено одне або кілька обов’язкових полів",
  "upt-city---header": "Місто можна змінити певну кількість разів ({change_time}) протягом 6 місяців.",
  "Fleet_Resdesign_Friday_GxZE": "Пт",
  "Fleet_Resdesign_Tuesday_UAxw": "Вт",
  "Fleet_Resdesign_Balance_GHxU": "Профіль",
  "Fleet_Resdesign_Cash_collection_eETn": "Оплата готівкою",
  "Fleet_Resdesign_Start_end_Nnvy": "П/К",
  "Fleet_Resdesign_Account_Amount_kIgR": "Депозит профілю",
  "balance_v1---withdraw": "Зняти",
  "Fleet_Wording_Balance_YWuq": "Баланс",
  "Fleet_Resdesign_Total_income_hyAh": "Загальний чистий дохід",
  "Fleet_Resdesign_Withdrawal_records_KMxk": "Історія виведення готівки",
  "Fleet_Resdesign_Not_selected_xuLq": "Вибір скасовано",
  "Fleet_DriverUnbindFleet_Untied_cPMi": "Вимкнені",
  "Fleet_Resdesign_Online_SILV": "Онлайн",
  "Fleet_Resdesign_Saved_Rbay": "Збережено",
  "Fleet_Resdesign_Data_loading_WbGr": "Дані завантажено",
  "upt-city---submit": "Змінити місто",
  "Fleet_Resdesign_Today_s_yBsy": "Дохід за сьогодні",
  "Fleet_Resdesign_December_uJlY": "Груд",
  "Fleet_Resdesign_Send_csv_ngwh": "Надіслати звіт у форматі CSV електронною поштою",
  "Fleet_MultiUserLogin_Mobile_number_RzUl": "Примітка. Якщо ви приймете це запрошення, то не зможете використовувати цей номер мобільного телефону, щоб зареєструватися як водій або партнер-власник автопарку.",
  "Fleet_Resdesign_Total_unit_iLuD": "Усього поїздок",
  "my_wallet": "Мій гаманець",
  "unbindTips": "Ви хочете вилучити цей автомобіль? Водій не зможе користуватися ним.",
  "unbindSuccessTips": "Вимкнені",
  "bindTips": "Прив’язати цей автомобіль до цього водія?",
  "bindSuccessTips": "Приєднано",
  "Fleet_Tool_Links_are_ennN": "Link Expired",
  "Fleet_NewPaymentFlow__NhvB": "Amount: {{Price}}. Charged from: {{begin_datetime}}. Frequency: {{Frequency}}.",
  "Fleet_deactivation_sjNc_YjtD": "Cancel",
  "Fleet_perception__ndnz": "Earnings Guide",
  "Fleet_NewPaymentFlow_xuka_dUSy": "If you switch to Automatic Collection, rental fees and other expenses will be collected automatically from the driver’s Wallet. If they don’t have sufficient balance. you’ll need to collect the rest from the driver offline",
  "Fleet_Drivers_Confirm_deletion_aXtK": "Delete Rule Now?",
  "Fleet_Drivers_Select_Name_OoCI": "Select Name",
  "Fleet_control_ZNQC_ZwIi": "{{Fleet_name}} invited you to join their fleet",
  "Fleet_check_aUhi_hmNL": "{{brand_name}} needs to access your Photo Album so you can set your profile photo and use other services.",
  "Fleet_NewPaymentFlow_svTo_tbpj": "To change the collection method, please go to Me > Settings",
  "Fleet_check_ejnS_VZqp": "This photo will be your profile photo. We suggest that you:",
  "Fleet_NewPaymentFlow__xbNM": "Add a New Expense",
  "Fleet_check_OaNq_asGe": "Profile Photo Uploaded",
  "Fleet_MatchingTool_Loading_ingu": "Loading",
  "Fleet_Drivers_Name_can_JcFB": "Name cannot be blank",
  "Fleet_control_mIEb_goHs": "Accept",
  "Fleet_Mgt__gsvK": "Rent Out",
  "Fleet_NewPaymentFlow__UJcK": "My Earnings",
  "Fleet_NewPaymentFlow__djTl": "Total",
  "Fleet_check_TNKJ_sfGt": "Don’t wear accessories like hats/sunglasses",
  "Fleet_Phase1_There_are_TYqj": "Find skilled drivers here",
  "Fleet_NewPaymentFlow_utjU_KAIH": "Offline",
  "Fleet_Drivers_Rule_number_hDmV": "Rule {{number}}",
  "Fleet_NewPaymentFlow__otGL": "All Bills",
  "Fleet_NewPaymentFlow__fiLG": "Unreceived",
  "Fleet_check_zWwS_DPsT": "Position your face in the center of the screen",
  "Fleet_check_HWak_qoaq": "Upload Profile Photo",
  "Fleet_Drivers_Add_Rules_KTVL": "Add Rule",
  "Fleet_NewPaymentFlow_ebKy_pywA": "Received",
  "Fleet_optimizaton__ZYCj": "Add vehicles here",
  "Fleet_start__sbZS": "Back",
  "Fleet_Drivers_To_register_MgmZ": "Sign Up",
  "Fleet_copy_Driver_XTmX": "Drivers",
  "Fleet_Phase1_Driver_Market_lUUD": "Find Drivers",
  "Fleet_Mgt_Delete_the_cmct": "Delete this vehicle?",
  "Fleet_Drivers_The_driver_mSzg": "Work rules for this driver were saved.",
  "Fleet_Drivers_Delete_NcPF": "Delete",
  "Fleet_check_qxdW_jahK": "Keep your face centered",
  "Fleet_start_DumJ_PRKC": "{{amount}} added",
  "Fleet_issue_eOHq_BsKZ": "Total Tax",
  "Fleet_NewPaymentFlow_QOhW_ZVsb": "Unlink Vehicle?",
  "Fleet_NewPaymentFlow__nIsf": "Received Offline",
  "Fleet_NewPaymentFlow_wngD_YWNt": "In effect",
  "Fleet_Mgt_Change_color_ddUl": "Change Color",
  "Fleet_optimizaton__AoyP": "Documents must be approved before you can use this feature",
  "Fleet_issue_mmrE_nuXS": "Tax Details",
  "Fleet_NewPaymentFlow__wxAJ": "Driver Performance",
  "Fleet_Drivers_Invitation_to_dIQW": "Invitation Sent",
  "Fleet_check_ELEN_crck": "It typically takes us 24 to 48 hours to review profile photos. We’ll notify you of the review result via SMS and email.",
  "Fintech_Payment_management_View_the_VZZP": "View Balance History",
  "Fleet_Tool_Untied_successfully_dutX": "Successfully Left Fleet",
  "Fleet_perception_zHgs_UzNz": "Total Net Earnings",
  "Fleet_Tool_Click_to_DNOM": "Tap to view",
  "Fleet_perception_vSVy_IyMZ": "Cash Payments",
  "Fleet_NewPaymentFlow_owVN_GnVJ": "Expense Collection Method",
  "Fleet_NewPaymentFlow_fsqE_HdZG": "Unreceived",
  "Fleet_NewPaymentFlow__yfXt": "Edit Expense",
  "Fleet_copy_Deleted_successfully_Mafm": "Deleted successfully",
  "Fleet_control_1_lIfT": "You are seeing this page because your account is in arrears. This is the result of your fleet drivers accepting more Cash Payment trips than Online Payment trips, and payments received online are insufficient to cover the platform deductions owed for Cash Payment trips. You may view your account’s total accumulated arrears, or download a report to view individual arrears of each driver.",
  "Fleet_Drivers_Confirm_that_HlwF": "Are you sure you want to delete Rule {{number}}? Once deleted, this content will be lost",
  "Fleet_Drivers_Bind_cCCG": "Added",
  "Fleet_Drivers_Select_frequency_YcRq": "Select Frequency",
  "Fleet_NewPaymentFlow_cfGZ_kjVX": "The current vehicle has unpaid expenses. Please unlink the vehicle from the driver, then try to change the collection method",
  "Fleet_Mgt_Loosen_immediately_OZaY": "Release to refresh",
  "Fleet_control_OK_sQYN": "Got It",
  "Fintech_Payment_Agency__klZT": "Show More",
  "Fleet_Drivers_Please_set_YncL": "Set Work Rules",
  "Fleet_NewPaymentFlow__uHzl": "Total amount of effective expenses received in the selected period. Includes amounts received but not withdrawn, received and withdrawn and received offline",
  "Fleet_Phase3_Set_ozBm": "Settings",
  "Fleet_control_The_two_wIUS": "The platform supports two repayment methods: Repayment with a bank card, which typically clears within 10 minutes, and offline repayment, which typically clears within 1 to 2 business days. To view your repayment status, tap the button on the top right. If a repayment is not successfully deposited on time, please contact {{mx_contact_info}}",
  "Fleet_NewPaymentFlow__RjDW": "Frequency",
  "Fleet_NewPaymentFlow__ltIu": "Rental fees and other expenses will be collected automatically from the driver’s Wallet. If they don’t have sufficient balance, you’ll need to collect the rest from the driver offline",
  "Fleet_NewPaymentFlow__cGLW": "Please note that after you accept an invitation and successfully join a fleet, the fleet partner will be able to add or edit an expense without further confirmation from you.",
  "Fleet_Drivers_Amount_YOtw": "Amount",
  "Fleet_check_IYER_eDig": "You can only link vehicles to drivers in your fleet after your profile photo is approved.",
  "Fleet_check_PFze_fown": "Profile Photo Review in Progress",
  "Fleet_NewPaymentFlow__BFLZ": "Next",
  "Fleet_NewPaymentFlow_LJUV_JguU": "If you switch to Offline Collection, expenses will not be deducted automatically from the driver’s Wallet, and you’ll need to collect payments from the driver offline",
  "Fleet_Mgt_Are_you_QgSa": "Are you sure you want to delete this vehicle?",
  "Fleet_NewPaymentFlow_OSHq_PQkz": "Please select a vehicle",
  "Fleet_Drivers_Enter_verification_AAuw": "Enter Verification Code",
  "Fleet_Drivers_Enter_the_WTcT": "Enter the amount you will get",
  "Fleet_NewPaymentFlow_gXEl_ipjf": "Not in effect",
  "Fleet_check_OZWz_BEqb": "Upload Now",
  "Fleet_NewPaymentFlow__yzdB": "Vehicle Details",
  "Fleet_check_vdqm_jUYr": "Don’t Show Again",
  "Fleet_Drivers_Rules_of_YEUJ": "Work Rules Saved",
  "Fleet_NewPaymentFlow__VAgV": "Show More",
  "Fleet_NewPaymentFlow__OPXo": "Disable This Expense?",
  "Fleet_Mgt_No_more_mlms": "No more to view",
  "Fleet_copy_Bind_the_USYf": "Add Vehicles",
  "Fleet_Drivers_Select_the_njUQ": "Select fee name",
  "Fleet_optimizaton__sPaq": "The documents you submitted are still under review, or one or more documents didn’t pass review. You can open the app to add vehicles and try out various product features.",
  "Fleet_Mgt_Vehicles_GLnp": "Vehicles",
  "Fleet_Drivers_Add_a_rMLY": "Add Driver",
  "Fleet_Drivers_Vehicle_binding_mfjS": "Add Vehicle",
  "Fleet_NewPaymentFlow__PRyq": "Daily",
  "Fleet_Drivers_Please_set_nduh": "Set Work Regime",
  "Fleet_start__dyuk": "Add Vehicles",
  "Fleet_Drivers_Mobile_number_sgwd": "Mobile Number",
  "Fleet_NewPaymentFlow__IogO": "Total Received",
  "Fleet_NewPaymentFlow__zuWo": "Driver’s mobile number: {{phone_num}}",
  "Fleet_NewPaymentFlow__oIIp": "Bill List",
  "Fleet_check_GbcB_hlpe": "Please upload a profile photo as required below. If your photo is declined, you may not be able to access some features.",
  "Fleet_perception__gmNA": "Download Report",
  "Fleet_check_GKhX_RGRf": "Ensure photo is well-lit with no filters",
  "Fleet_Drivers_Select_the_tKMG": "Select billing frequency",
  "Fleet_Tool_You_need_ewbc": "Please confirm to leave the fleet within 7 days. This link expires in 7 days, after which you will need to contact Customer Support again",
  "Fleet_perception_Ferf_lkOZ": "Account Deposits",
  "Fleet_Drivers_Save_feyd": "Save",
  "Fleet_Drivers_Daily_00_kmqY": "Daily: Charged every day between 00:00–12:00\nWeekly: Charged every Monday between 00:00–12:00\nMonthly: Charged the first day of every month between 00:00–12:00",
  "Fleet_check_UBBv_ALyB": "Don’t wear accessories",
  "Fleet_Drivers_Are_you_uWrh": "Heads up! Are you sure you want to delete this rule?",
  "Fleet_start_VrwW_czSn": "Sign Out",
  "Fleet_payment_Payment_Method_vmsQ": "Payment method",
  "Fleet_NewPaymentFlow__xwbw": "Download Report",
  "Fleet_start__pvQo": "None added",
  "Fleet_start__ASwv": "Hide Beginners Guide from homepage?",
  "Fleet_optimizaton__OUwE": "Documents Under Review",
  "Fleet_NewPaymentFlow_ozwI_goeV": "Disabled",
  "Fleet_start_aTFD_HHTY": "About App",
  "Fleet_NewPaymentFlow__bEhi": "Rental fees and other expenses will be automatically deducted from your Wallet",
  "Fleet_NewPaymentFlow__EBXA": "Offline Collection: You will need to pay rental fees and other expenses to the fleet partner offline",
  "Fleet_NewPaymentFlow__xLMz": "Rental fees and other expenses will need to be settled with the fleet partner offline",
  "Fleet_Drivers_Cancel_YjzD": "Cancel",
  "Fleet_Drivers_Frequency_can_jPlc": "Frequency cannot be blank",
  "Fleet_control2_Vehicles_not_cNeS": "Unable to Remove Vehicle",
  "Fleet_NewPaymentFlow__HtrY": "Accept",
  "Fleet_NewPaymentFlow__ZxdF": "Received Amount Details",
  "Fleet_NewPaymentFlow_ppMF_fAZz": "Please Unlink Vehicle First",
  "Fleet_check_KSPJ_glKu": "Upload",
  "Fleet_issue_uzuL_mYUR": "We recommend you subtract this amount from the driver’s Total Net Earnings (Before Tax) and Deposits (Before Tax). Tap for more info.",
  "Fleet_Drivers_The_driver_haLf": "Unable to add driver because their account is in arrears",
  "Fleet_NewPaymentFlow__sXzn": "Edit Expense",
  "Fleet_copy_No_vehicle_KXvt": "No vehicles added",
  "Fleet_perception__mEjw": "Fleet Earnings Breakdown",
  "Fleet_Drivers_At_the_IfBL": "Start Date",
  "Fleet_control_You_can_UzFy": "Vehicles cannot be removed from the fleet until your recent arrears have been paid.",
  "Fleet_control_Repayment_records_uMeU": "Repayment History",
  "Fleet_Drivers_Confirmation_wvYD": "Confirm",
  "Fleet_Mgt_Please_select_zmgM": "Please select at least one vehicle",
  "Fleet_NewPaymentFlow__tgtT": "Rental Fee",
  "Fleet_copy_Vehicles_dwty": "Vehicles",
  "Fleet_check_CBpH_TcGJ": "Choose a simple background, like white",
  "Fleet_issue_wggA_MxPE": "Total Net Earnings (After Tax)",
  "Fleet_issue_aIsE_dmqL": "All Drivers",
  "Fleet_Drivers_Go_Bind_TxwZ": "Add",
  "Fleet_start_vHHF_ayCO": "Account Security",
  "Fleet_Drivers_Go_Settings_vpjg": "Setup",
  "Fleet_NewPaymentFlow__WiKw": "Details",
  "Fleet_Drivers_Settings_zKsG": "Setup complete",
  "Fleet_check_uiYb_OxPW": "Your profile photo was declined {{reject_max_time}} times. To use this feature, please upload a valid photo and wait for approval.",
  "Fleet_check_kLTg_CIuk": "Take Photo",
  "Fleet_NewPaymentFlow__gTTE": "Received Online",
  "Fleet_Drivers_Please_complete_CZYg": "Please first complete all fields for this rule",
  "Fleet_check_hceA_ycnc": "Got It",
  "Fleet_NewPaymentFlow__qbqz": "Total Amount Received",
  "Fleet_NewPaymentFlow__GUTP": "One-time Fee",
  "Fleet_check_OQKj_GHLS": "You can only link vehicles to drivers after your profile photo is approved.",
  "Fleet_check_fBNK_CTjZ": "You can only invite drivers after your profile photo is approved.",
  "Fleet_issue_sumF_oFSJ": "Generated Tax",
  "Fleet_start__VNTW": "You haven’t added any vehicles.Tap “+” to add one",
  "Fleet_Drivers_Please_set_HvnQ": "Please set up work regime",
  "Fleet_start_pHZA_kozl": "Are you sure you want to sign out?",
  "Fleet_optimizaton__GwKg": "Your documents must be approved before you can access the Find Drivers feature and add drivers",
  "Fleet_Phase2_Invitation_accepted_jUWV": "Invite accepted",
  "Fleet_Drivers_Verification_code_EAbp": "Verification Code sent to {{phone_number}}",
  "Fleet_copy_Add_a_QOUx": "Add Documents",
  "Fleet_NewPaymentFlow__sJZs": "Fleet Invitation",
  "Fleet_NewPaymentFlow__JGoj": "Collection Method",
  "Fleet_control_The_total_Mche": "Your arrears amount has been waived, and your balance will be re-calculated. If the amount in arrears subsequently becomes too high, all drivers with the fleet will be unable to accept cash trips until you pay off the arrears amount.",
  "Fleet_NewPaymentFlow__Wzlo": "Set up rental fees and other expenses",
  "Fleet_perception__SzYM": "Fleet Performance",
  "Fleet_Mgt_Question_feedback_uwFO": "Feedback",
  "Fleet_check_wRSz_suag": "Allow",
  "Fleet_NewPaymentFlow_lHPn_FNIg": "Please enter an expense name",
  "Fleet_NewPaymentFlow_ecXd_ctUR": "Expense Type",
  "Fleet_start__EurG": "You haven’t added any drivers. Tap to invite or find one",
  "Fleet_Mgt_No_information_DDuc": "No Information",
  "Fleet_Drivers_Add_slkd": "Add",
  "Fleet_Drivers_The_driver_AvoC": "All of the driver’s documents were approved!",
  "Fleet_Drivers_Confirmation_jXFy": "Confirm",
  "Fleet_NewPaymentFlow__Qbnn": "Total amount of unreceived effective expenses in the selected period",
  "Fleet_NewPaymentFlow__pMHK": "Bill List",
  "Fleet_control_Please_check_tIFA": "Before unlinking this driver from the fleet, please ensure that they do not have any outstanding arrears. Are you sure you want to unlink this driver?",
  "Fleet_start__OCpm": "Saved Successfully",
  "Fleet_NewPaymentFlow__GwuJ": "Notes",
  "Fleet_NewPaymentFlow_BBWr_ImCE": "The current vehicle has unpaid expenses. Please unlink the vehicle from the driver, then try to delete it",
  "Fleet_Tool_Unable_to_jqFL": "Unable to leave fleet. Please try again later",
  "Fleet_Drivers_Next_step_PxoK": "Next",
  "Fleet_copy_Change_UEsW": "Edit",
  "Fleet_NewPaymentFlow__xiMh": "Collect Offline",
  "Fleet_NewPaymentFlow_TMhC_InJP": "Are you sure you want to delete this vehicle?",
  "Fleet_deactivation_DenK_QPgy": "Add New Vehicle",
  "Fleet_Mgt_Send_a_orZR": "Send Statement",
  "Fleet_NewPaymentFlow__GCoA": "Effective Date",
  "Fleet_start__kQXw": "Enable Beginners Guide",
  "Fleet_NewPaymentFlow__EnGk": "Deduction Date",
  "Fleet_Drivers_The_driver_wclR": "Unable to add driver because they have joined another fleet",
  "Fleet_start__MHFQ": "Add a Bank Card",
  "Fleet_Mgt_Driver_performance_pmda": "Driver Performance",
  "Fleet_deactivation_AxQl_axxa": "You didn’t reply to driver’s message(s) in time, so the related vehicle(s) were removed.",
  "Fleet_Tool_Confirmation_of_xfhT": "Confirm to Leave Fleet",
  "Fleet_Mgt_Select_date_INmY": "Select Dates",
  "Fleet_perception__LHEy": "(Me)",
  "Fleet_NewPaymentFlow__ZQOF": "Next",
  "Fleet_Drivers_The_invitation_ytYi": "An invite link was sent to the driver. Please wait for them to accept it.",
  "Fleet_Drivers_Please_help_ZYii": "To add this driver, please help them sign up for an account.",
  "Fleet_NewPaymentFlow__AMrP": "You’ll need to collect rental fees and other expenses from the driver offline",
  "Fleet_issue_PMnB_Wfat": "Deposits (Before Tax)",
  "Fleet_start__SeMT": "Invite drivers you know, or contact other drivers using the “Find Drivers” feature",
  "Fleet_NewPaymentFlow__VoUq": "If you disable this expense, you will no longer receive payments for it starting from the next collection period",
  "Fleet_check_dPXn_jSAI": "Privacy Policy",
  "Fleet_optimizaton__AfWb": "View Review Progress",
  "Fleet_Mgt_Vehicle_Details_ihSv": "Vehicle Details",
  "Fleet_Mgt_Pull_down_YzpV": "Pull down to refresh",
  "Fleet_NewPaymentFlow__TkSG": "Contact Fleet",
  "Fleet_Drivers_Start_date_GZYy": "Start date cannot be blank",
  "Fleet_Drivers_Frequency_mzAO": "Frequency",
  "Fleet_perception__iBGo": "Driver Performance",
  "Fleet_NewPaymentFlow_sKlJ_uHRX": "Expense {{num}}",
  "Fleet_NewPaymentFlow__PsNL": "Total Receivable Amount",
  "Fleet_NewPaymentFlow_ayYQ_vGUU": "Driver’s mobile number",
  "Fleet_Tool_Front_Recommended_giVU": "Recommended Fleets",
  "Fleet_Tool_Want_to_aUcS": "Want to join another fleet?",
  "Fleet_NewPaymentFlow__aQyj": "Add Other Expenses",
  "Fleet_NewPaymentFlow__oKdN": "Add Offline Collection Record",
  "Fleet_control_FAQ_djfs": "FAQ",
  "Fleet_check_pajT_vPwq": "Please Upload a Profile Photo",
  "Fleet_Tool_If_you_dYhg": "To make another request to leave the fleet, please contact Customer Support",
  "Fleet_rental_Week_wLOx": "week",
  "Fleet_Drivers_Enter_the_fNet": "Enter the amount you will get from this driver at the frequency chosen below",
  "Fleet_control_Withdrawal_and_dAGM": "Withdrawal and Payment History",
  "Fleet_Drivers_The_driver_FaYT": "The work rules for this driver have been saved. To finish adding the driver, please help them complete driver registration",
  "Fleet_Tool_You_have_Trbx": "You successfully left the fleet. Please contact the fleet to return the vehicle",
  "Fleet_NewPaymentFlow__upZL": "Expense Type",
  "Fleet_Mgt__Express_dSGM": "{{Express}}",
  "Fleet_NewPaymentFlow__ELan": "Effective Date",
  "Fleet_NewPaymentFlow__cQQc": "Unreceived",
  "Fleet_start__JhMH": "If disabled, you won’t see it on the homepage",
  "Fleet_NewPaymentFlow__nJcc": "All Drivers",
  "Fleet_start__ikUr": "List your vehicle so drivers who are looking to rent one can see",
  "Fleet_NewPaymentFlow_mTod_iDbL": "Receivables",
  "Fleet_Drivers_Separation_rules_eXvM": "Work Regime",
  "Fleet_start_UcCd_UVKp": "{{app_name}} Match",
  "Fleet_copy_Remove_vehicle_DDrG": "Remove Vehicles",
  "Fleet_NewPaymentFlow__GiSP": "Effective Date",
  "Fleet_Drivers_Select_a_yuVt": "Select start date",
  "Fleet_NewPaymentFlow__vurJ": "Automatic Collection: Rental fees and other expenses will be deducted automatically from your Wallet. If your balance is insufficient, you’ll need to pay the rest to the fleet partner offline",
  "Fleet_issue_WMHZ_ZyWR": "Total Net Earnings (Before Tax)",
  "Fleet_start__xLsd": "Go Now",
  "Fleet_NewPaymentFlow__wclB": "Please read and confirm the rental fees and other expenses info. Tap Accept to join the fleet",
  "Fleet_NewPaymentFlow__XoLO": "Total amount of effective expenses in the selected period",
  "Fleet_Drivers_Enter_a_HciF": "Please enter a valid mobile number",
  "Fleet_NewPaymentFlow__ydGV": "Rental Info",
  "Fleet_control_pbwt_loki": "Not Now",
  "Fleet_deactivation_xUfQ_GyUZ": "Your vehicle(s) were removed",
  "Fleet_perception__oMHQ": "View Details",
  "Fleet_Drivers_Enter_the_Iqvb": "Enter Driver’s Mobile Number",
  "Fleet_check_tint_NtpW": "We will notify you of the review result within <span>24 to 48 hours</span> via SMS and email.",
  "Fleet_Drivers_There_are_mefN": "Some rules are still incomplete. If you save now, any incomplete rules will be lost",
  "Fleet_perception__TFIy": "Earnings Details",
  "Fleet_Drivers_Confirm_deletion_XNBw": "Delete Rule {{number}}?",
  "Fleet_control_GyDm_gKOe": "Contact Fleet Partner",
  "Fleet_Mgt_Editing_documents_khkk": "Edit Document",
  "Fleet_NewPaymentFlow_xaDm_BLCM": "The current vehicle has unpaid expenses of {{Price}}. Please settle the amount first. If you’ve received payment, you can adjust the unsettled amount to 0",
  "Fleet_Drivers_The_amount_WtWG": "Amount cannot be blank",
  "Fleet_NewPaymentFlow__znZG": "This driver has unpaid expenses of {{Price}}. Please settle the amount first. If you’ve received payment, you can adjust the unsettled amount to 0",
  "Fleet_control2_Are_you_Pujl": "Remove Driver?",
  "Fleet_copy_Vehicle_list_PmvG": "Vehicles list is empty",
  "Fleet_check_Admw_cABo": "Not Now",
  "Fleet_check_XDUC_GDrR": "Example",
  "Fleet_Tool_Cancel_axjb": "Cancel",
  "Fleet_NewPaymentFlow__Khbs": "Automatic",
  "Fleet_start__eaYV": "You can add it back anytime by going to Me > Settings",
  "Fleet_Tool_Confirmation_vzhv": "Confirm",
  "Fleet_NewPaymentFlow__DRkc": "Disable Expense",
  "Fleet_Drivers_Content_may_ZBiI": "Content May Be Lost",
  "Fleet_check_LJzu_FVZT": "Show your full face",
  "Fleet_Phase1_Go_vwbQ": "Go",
  "Fleet_start__rZdn": "Beginners Guide",
  "Fleet_NewPaymentFlow__VKFl": "Not Now",
  "Fleet_NewPaymentFlow__MfyW": "{{Fleet_name}} invited you to join their fleet",
  "Fleet_NewPaymentFlow__owTK": "Select a vehicle for the driver",
  "Fleet_start__AAdW": "Invite Drivers",
  "Fleet_NewPaymentFlow__yYUL": "Remove This Driver?",
  "Fleet_Drivers_Return_Driver_SuUV": "Back to Driver List",
  "Fleet_NewPaymentFlow__CFxF": "Driver’s Bill Details",
  "Fleet_NewPaymentFlow_FMtz_Fgwk": "Switch to Offline Collection?",
  "Fleet_NewPaymentFlow_MOPD_sBcZ": "Received",
  "Fleet_check_bHXh_cGKL": "Your photo was approved and doesn’t need to be uploaded again",
  "Fleet_check_XKad_fPlI": "Please Re-Upload Profile Photo",
  "Fleet_NewPaymentFlow__Hecx": "Skip This Step",
  "Fleet_start__ndBl": "Hide from Homepage",
  "Fleet_NewPaymentFlow__IqzA": "Driver’s Bill List",
  "GDriver_model__chvL": "Top Up",
  "Fleet_NewPaymentFlow__ifcR": "Date Disabled",
  "Fleet_NewPaymentFlow_GZpD_WRgn": "Switch to Auto Collection?",
  "Fleet_NewPaymentFlow__BevI": "Weekly",
  "Fleet_Drivers_Name_nwDP": "Name",
  "Fleet_check_iuvA_xbpz": "Upload Profile Photo",
  "Fleet_Mgt_My_driver_nueB": "My Drivers",
  "Fleet_perception__akHT": "You have past arrears to be paid. To ensure you’re able to withdraw earnings, please remember to repay soon. Tap here for details.",
  "Fleet_issue_nMWy_QVYj": "Deposits (After Tax)",
  "Fleet_NewPaymentFlow_iJcz_jiCd": "Inviting",
  "Fleet_start__tmar": "Back",
  "Fleet_copy_My_pzKZ": "Me",
  "Fleet_NewPaymentFlow__eItp": "Received",
  "Fleet_NewPaymentFlow_BoPa_SvIW": "Online",
  "Fleet_NewPaymentFlow__BVvn": "Offline",
  "Fleet_check_fHaJ_tEra": "Take the photo from the shoulders up",
  "Fleet_check_mDSh_CVHS": "Your photo should meet the following requirements",
  "Fleet_NewPaymentFlow__Mhyi": "Delete"
}